import React, { Component } from 'react';

// import A from '../analytics';

export default class NewPasswordInput extends Component {
  state = {
    show: false,
    val: this.props.value || '',
  };

  onChange = e => {
    this.props.onChange(e);
    this.setState({ val: e.target.value });
  };

  toggleShow = () => {
    const { show } = this.state;
    this.setState({ show: !show });

    // A.logClick('SHOW_PASSWORD', String(show));
  };

  render() {
    const { show, val } = this.state;
    const { name, value, loading = false, placeholder = '' } = this.props;
    return (
      // nameClass({ 'loading-input': loading })
      <div>
        <div className={{}}>
          <div className="new-password-box">
             <input
                placeholder={placeholder}
                name={name || 'password'}
                type={show ? 'text' : 'password'}
                onChange={this.onChange}
                value={value}
                // className="new-pass"
                id="new-pass"
                // disabled={loading}
                required
              />
            {!loading && !!val && (
              <i
                onDoubleClick={this.toggleShow}
                onClick={this.toggleShow}
                style={{ marginRight: '10px', marginTop: '4px' }}
                className={`icon-eye${show ? '' : '-slash'}`}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewPasswordInput/NewPasswordInput.js